"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = _interopRequireDefault(require("../../styles/theme"));

var _cards = require("../../styles/cards");

var _Ellipsis = _interopRequireDefault(require("../../svg/Ellipsis"));

var _utils = require("../../helpers/utils");

var _ = require("../..");

var _Heart = require("styled-icons/feather/Heart");

var _text = _interopRequireDefault(require("../text"));

var _button = _interopRequireDefault(require("../buttons/button"));

var _Plus = require("styled-icons/feather/Plus");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AddToCart = function AddToCart(props) {
  return /*#__PURE__*/_react["default"].createElement(_cards.AddToCartContainer, null, /*#__PURE__*/_react["default"].createElement(_Plus.Plus, {
    color: _theme["default"]["default"].primary,
    height: 18,
    width: 18
  }));
};

var Discount = function Discount(props) {
  return /*#__PURE__*/_react["default"].createElement(_cards.DiscountContainer, null, /*#__PURE__*/_react["default"].createElement(_cards.DiscountAmount, null, props.discount), /*#__PURE__*/_react["default"].createElement(_cards.DiscountPercent, null, "%"), /*#__PURE__*/_react["default"].createElement(_cards.DiscountOff, null, "OFF"));
};

var ProductRating = function ProductRating(props) {
  return /*#__PURE__*/_react["default"].createElement(_cards.RatingContainer, null, /*#__PURE__*/_react["default"].createElement(_.Rating, {
    rating: props.rating,
    maxRating: 5,
    size: 10
  }));
};

var ProductPrice = function ProductPrice(props) {
  var discount = "";
  var content = "";

  if (props.referencePrice != props.currentPrice) {
    var referencePrice = (0, _utils.getFormattedCurrency)(props.referencePrice);
    discount = /*#__PURE__*/_react["default"].createElement(_cards.PriceFormatter, {
      price: referencePrice,
      isDiscount: true,
      hasDiscount: false
    });
  }

  var currentPrice = (0, _utils.getFormattedCurrency)(props.currentPrice);
  content = /*#__PURE__*/_react["default"].createElement(_cards.PriceFormatter, {
    price: currentPrice,
    isDiscount: false,
    hasDiscount: props.referencePrice != props.currentPrice
  });
  return /*#__PURE__*/_react["default"].createElement(_cards.PriceContainer, null, discount, content);
};

var _default = function _default(props) {
  var handleIconClick = function handleIconClick(e) {
    e.stopPropagation();

    if (props.onClickIcon) {
      props.onClickIcon();
    }
  };

  var handleAddToCart = function handleAddToCart(e) {
    e.stopPropagation();

    if (props.onAddToCart) {
      props.onAddToCart();
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_cards.ProductCardContainer, {
    onClick: props.onClick
  }, props.isSoldOut && /*#__PURE__*/_react["default"].createElement(_cards.OverImage, {
    position: "upper-left",
    padding: "0",
    width: "inherit",
    height: "inherit",
    zIndex: 50
  }, /*#__PURE__*/_react["default"].createElement(_cards.TransparentOverlay, null)), /*#__PURE__*/_react["default"].createElement(_cards.ImageContainer, null, props.isSoldOut && /*#__PURE__*/_react["default"].createElement(_cards.OverImage, {
    position: "upper-left",
    padding: 0,
    left: "50%",
    top: "50%",
    zIndex: 70
  }, /*#__PURE__*/_react["default"].createElement(_cards.SoldOut, null, "Out of Stock")), props.discount > 0 && /*#__PURE__*/_react["default"].createElement(Discount, {
    discount: props.discount
  }), /*#__PURE__*/_react["default"].createElement(_cards.ProductImage, {
    src: props.cardImgSrc
  })), /*#__PURE__*/_react["default"].createElement(_cards.ProductDetails, null, /*#__PURE__*/_react["default"].createElement(_cards.CategoryAndProductNameBox, null, /*#__PURE__*/_react["default"].createElement(_cards.ProductName, null, props.productName)), /*#__PURE__*/_react["default"].createElement(_cards.ProductPriceAndRatingBox, null, /*#__PURE__*/_react["default"].createElement(ProductPrice, {
    currentPrice: props.currentPrice,
    referencePrice: props.referencePrice
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: "0.5rem"
    }
  }), /*#__PURE__*/_react["default"].createElement(ProductRating, {
    rating: props.rating
  }))));
};

exports["default"] = _default;
module.exports = exports["default"];